import React, { useMemo } from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';
import { usePageNotice } from '../../context/FeedbackContext';

function SettingsSectionCard({ title, description, children, error, success, successMessage }) {
  const noticeId = useMemo(() => `settings-${title}`, [title]);

  usePageNotice(
    `${noticeId}-error`,
    error ? { message: error, severity: 'error', persist: true } : null,
  );
  usePageNotice(
    `${noticeId}-success`,
    success && successMessage
      ? { message: successMessage, severity: 'success', persist: true }
      : null,
  );

  return (
    <Paper elevation={1} sx={{ overflow: 'hidden', borderRadius: 2 }}>
      <Box sx={{ px: 3, py: 2, bgcolor: 'grey.50' }}>
        <Typography variant="h6" fontWeight={700}>{title}</Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
      <Divider />
      <Box sx={{ px: 3, py: 2.5 }}>
        {children}
      </Box>
    </Paper>
  );
}

export default SettingsSectionCard;
